import { Component } from '@angular/core';

@Component({
  selector: 'app-extra-page',
  templateUrl: './extra-page.component.html',
  styleUrls: ['./extra-page.component.css']
})
export class ExtraPageComponent {

}
